<template>
  <nav class="global-navbar">
    <!-- top-navbar -->
    <nav id="topNavbar" class="top-navbar">
      <div class="container">
        <!-- navbar-container -->
        <div class="navbar-container" >
          <router-link to="/">
            <img
              class="navbar-brand-img"
              src="@/assets/public/images/navbar/navbar-logo.svg"
              alt
            />
          </router-link>
          <div class="navbar-list">
            <router-link to="/download-docs">下載文件</router-link>
            <div class="navbar-divider"></div>
            <a rel="noopener" href="https://en.fordays.jp/" target="_blank"
              >Global Site</a
            >
            <!-- <img class="navbar-app-img" src="@/assets/public/images/app_QR_Code.jpg" alt /> -->
          </div>
          <button class="navbar-toggle-btn" @click="toggleNavbarList">
            <span class="navbar-toggle-line"></span>
          </button>
        </div>
        <!-- navbar-container end -->
      </div>
    </nav>
    <!-- top-navbar end -->
    <!-- main-navbar  -->
    <nav class="main-navbar">
      <div class="container">
        <div :class="['main-navbar-list', { active: isNavbarListActive }]">
          <router-link to="/kakusan">何謂核酸？</router-link>
          <router-link to="/safety">富地滋的品質</router-link>
          <router-link to="/products">產品資訊</router-link>
          <router-link to="/news">最新消息</router-link>
          <!-- <router-link to="/activity-list">活動訊息</router-link> -->
          <router-link to="/contribution">社會貢獻</router-link>
          <router-link to="/company">企業情報</router-link>
          <!-- <router-link to="/login" class="red-gradient-btn"
            >會員專區</router-link> -->
          <img class="navbar-app-img" src="@/assets/public/images/app_QR_Code.jpg" alt />
          <div class="d-sm-none text-center py-3">
            <a
              class="mx-2"
              rel="noopener"
              href="https://en.fordays.jp/"
              target="_blank"
              >Global Site</a
            >
            <router-link class="mx-2" to="/download-docs">下載文件</router-link> 
          </div>
        </div>
      </div>
    </nav>
    <!-- main-navbar end -->     
  </nav> 
</template>
<script>
export default {
  name: "PublicNavbar",
  data() {
    return {
      isNavbarListActive: false,
    };
  },
  methods: {
    toggleNavbarList() {
      this.isNavbarListActive = !this.isNavbarListActive;
    },
  },
};
</script>
